'use client'

import React, { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'

import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { AlertTriangle } from 'lucide-react';

interface ErrorProps {
  error: Error
  reset: () => void
}

export default function GlobalError({ error, reset }: ErrorProps) {
  const router = useRouter()

  useEffect(() => {
    console.error(error)
  }, [error])

  return (

        <div className="flex min-h-screen items-center justify-center bg-background p-4 md:p-8">
          <Card className="w-full max-w-md">
            <CardHeader className="text-center">
              <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-muted">
                <AlertTriangle className="h-10 w-10 text-destructive" />
              </div>
            </CardHeader>
            
            <CardContent className="text-center space-y-4">
              <h1 className="text-3xl font-bold tracking-tight">Something went wrong</h1>
              <p className="text-muted-foreground">Sorry, we couldn't load this page.</p>
              
              <Alert variant="destructive" className="mt-6">
                <AlertTitle>Error</AlertTitle>
                <AlertDescription className="text-sm">
                  An unexpected error occurred. Please try again or return to the homepage.
                </AlertDescription>
              </Alert>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                <Button variant="default" onClick={() => reset()}>
                  Try Again
                </Button>
                <Button variant="outline" asChild>
                  <Link href="/">Go to Home</Link>
                </Button>
              </div>
            </CardContent>
            
            <CardFooter className="justify-center">
              <p className="text-sm text-muted-foreground">
                If this problem persists, please contact support.
              </p>
            </CardFooter>
          </Card>
        </div>
  )
}